import {bindActionCreators} from 'redux';
import store from './index';
import {actionCreators as coreActions} from './modules/core';
import {actionCreators as nestActions} from './modules/nest';
import {actionCreators as thermostatsActions} from './modules/thermostats';

const {dispatch} = store;
export const CoreActions = bindActionCreators(coreActions, dispatch);
export const NestActions = bindActionCreators(nestActions, dispatch);
export const ThermostatsActions = bindActionCreators(thermostatsActions, dispatch);


// WEBPACK FOOTER //
// ./src/store/actionCreators.js